import useConfiguration from '@/composables/configuration/configuration'
import { computed, watch } from 'vue'
import usePostList from '@/composables/post/postList'

export default function useScrollManager() {
  const { configuration } = useConfiguration()
  const { postList } = usePostList()

  const getFunctionFromString = (string: string) => {
    let scope: any = window
    const scopeSplit: string[] = string.split('.')
    for (let i = 0; i < scopeSplit.length - 1; i++) {
      scope = scope[scopeSplit[i]]

      if (scope == undefined) return
    }

    return scope[scopeSplit[scopeSplit.length - 1]]
  }

  function getOffsetTop(elem: any) {
    let offsetTop = 0
    do {
      if (!isNaN(elem.offsetTop)) {
        offsetTop += elem.offsetTop
      }
    } while ((elem = elem.offsetParent))
    return offsetTop
  }

  function scrollToEl(elem: any, scrollBehaviour: ScrollBehavior = 'auto') {
    const offsetTop = getOffsetTop(elem)

    if (elem) {
      let offset = 0
      if (configuration.widget.scrollToPostOffsetCallback) {
        const callbackFn = getFunctionFromString(
          configuration.widget.scrollToPostOffsetCallback
        )
        if (typeof callbackFn === 'function') {
          try {
            offset = callbackFn()
          } catch (e) {
            console.error(e)
          }
        }
      }

      const newTop = offset > offsetTop ? offsetTop : offsetTop - offset

      window.scrollTo({
        top: newTop,
        behavior: scrollBehaviour,
      })
    }
  }

  const scrollToLastSaved = () => {
    const res = document.querySelector('.anz-post--lastSaved')
    if (res) {
      scrollToEl(res, 'smooth')
    }
  }

  const scrollToSelected = () => {
    const res = document.querySelector('.anz-post--selected')
    if (res) {
      scrollToEl(res)
    }
  }

  const allMounted = computed(() => {
    if (postList.length === 0) {
      return false
    }
    const firstNotMounted = postList.find(
      postRoot => postRoot.mounted === false && postRoot.missingParent === false
    )

    return typeof firstNotMounted === 'undefined'
  })

  watch(allMounted, allMounted => {
    if (allMounted) {
      scrollToSelected()
    }
  })

  return {
    allMounted,
    scrollToSelected,
    scrollToLastSaved,
  }
}
